import { useEffect, useState } from "react";
import Header from "@shared/components/Atoms/Contents/Header";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import { FOOTER } from "@shared/util/brand";
import { readConsent, saveConsent } from "@shared/util/cookieConsent";

export default function DoNotSellOrShare() {
  const email = FOOTER.email || "agent@videobrief.ai";
  const [optedOut, setOptedOut] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const c = readConsent();
    setOptedOut(Boolean(c?.doNotSellOrShare));
  }, []);

  const handleToggle = (enabled) => {
    const current = readConsent() || {
      functional: false,
      analytics: false,
      doNotSellOrShare: false,
    };
    saveConsent({ ...current, doNotSellOrShare: enabled });
    setOptedOut(enabled);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div>
      <a
        href="#compliance-main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg"
      >
        Skip to main content
      </a>
      <Header />
      <main id="compliance-main" className="container mx-auto px-4 py-8 max-w-4xl my-10">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">
          Do Not Sell or Share My Personal Information
        </h1>
        <div className="space-y-6 text-gray-700">
          <p>
            Under the California Consumer Privacy Act (CCPA) as amended by the California Privacy
            Rights Act (CPRA), California residents have the right to opt out of the{" "}
            <strong>sale</strong> or <strong>sharing</strong> of personal information.
          </p>
          <p>
            <strong>VideoBrief does not sell your personal information for money.</strong> We also
            do not share personal information with third parties for cross-context behavioral
            advertising. We use service providers (hosting, email, video, payments) only to operate
            the service under contract.
          </p>

          <div className="rounded-xl border border-gray-200 bg-gray-50 p-5">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Record your preference</h2>
            <p className="text-sm mb-4">
              Toggle below to store an opt-out signal in this browser. This complements our cookie
              preference center and applies to any future sharing covered by CCPA/CPRA.
            </p>
            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={optedOut}
                onChange={(e) => handleToggle(e.target.checked)}
                className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <span>
                <span className="font-medium block">Do Not Sell or Share My Personal Information</span>
                <span className="text-sm text-gray-600">
                  {optedOut
                    ? "Your opt-out preference is active in this browser."
                    : "You have not opted out in this browser."}
                </span>
              </span>
            </label>
            {saved && (
              <p className="text-sm text-green-700 mt-3" role="status" aria-live="polite">
                Preference saved.
              </p>
            )}
          </div>

          <h2 className="text-2xl font-semibold text-gray-900">Other California rights</h2>
          <p>
            You may request access, correction, or deletion of personal information, or limit use of
            sensitive personal information, by contacting{" "}
            <a href={`mailto:${email}`} className="text-blue-700 underline">
              {email}
            </a>
            . See our{" "}
            <a href="/privacy-policy" className="text-blue-700 underline">
              Privacy Policy
            </a>{" "}
            for details.
          </p>
        </div>
      </main>
      <FooterMain />
    </div>
  );
}
